import React from "react";
import styled, { keyframes } from "styled-components";

const moveAndRotate = keyframes`
  0% {
    transform: translate(0, 0) rotate(0deg);
  }
  25% {
    transform: translate(1px, 0px) rotate(2deg);
  }
  50% {
    transform: translate(1px, 0px) rotate(-1deg);
  }
  75% {
    transform: translate(0px, -1px) rotate(1deg);
  }
  100% {
    transform: translate(0, 0) rotate(0deg);
  }
`;

const AnimatedPath = styled.path`
  animation: ${moveAndRotate} ${({ duration }) => duration}s ease-in-out
    infinite;
  transform-origin: center;
  animation-play-state: ${({ isActive }) => (isActive ? "running" : "paused")};
`;

const StripesRockSvg = ({ isActive }) => {
  return (
    <svg
      width="257"
      height="121"
      viewBox="0 0 257 121"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <AnimatedPath
        isActive={isActive}
        duration={2.1}
        d="M86.4467 42.7894C85.9759 41.2826 84.6477 39.7303 83.7912 38.5051C78.7154 31.2442 73.3642 24.1427 67.6985 17.3314C63.0457 11.7379 57.7759 6.82357 52.3494 2"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <AnimatedPath
        isActive={isActive}
        duration={2.2}
        d="M72.4254 46.6134C54.5119 44.4199 37.083 38.6467 18.8894 38.6467"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <AnimatedPath
        isActive={isActive}
        duration={2.3}
        d="M51.3934 62.228C35.1336 66.5801 18.6817 67.943 2 69.5574"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <AnimatedPath
        isActive={isActive}
        duration={2.4}
        d="M208.581 74.4047C216.019 70.6448 225.33 70.1904 233.526 70.0142C240.955 69.8544 248.17 71.07 255.425 72.4927"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <AnimatedPath
        isActive={isActive}
        duration={2.5}
        d="M207.625 90.6567C216.408 91.6325 225.62 92.936 234.057 95.6138C236.632 96.4309 240.715 97.2972 242.679 99.2607"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <AnimatedPath
        isActive={isActive}
        duration={2.6}
        d="M185 105.315C189.011 110.286 193.173 114.878 198.065 119.018"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default StripesRockSvg;
